import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import Influencers from '@project/common/influencers';
import ProgressAdditionInfluencer from '@project/contents/workflow/progress/progress-addition-influencer';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

const ITEM_SIZE = 100;
const ITEM_HEIGHT = 64;

class SummaryMainScore extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      progress : null,
    };
  }
  // -------------------------------------------------------
  
  show(progress){
    this.setState({ progress: (this.state.progress != progress) ? progress : null });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    
    let total_count = Object.keys(workflow.influencers).length;
    
    let targets = [];
    for( let i in workflow.influencers ) targets.push(i);
    
    let groupScore = {
      candidate : { name: '候補者',       color: 'yellow', count: 0 },
      assign    : { name: 'アサイン対象', color: 'green',  count: 0 },
      execution : { name: '下書き～請求', color: 'blue',   count: 0 },
      ng        : { name: 'NG',           color: 'red',    count: 0 },
    };
    for( let i in workflow.influencers ){
      try { groupScore[workflow.influencers[i].progress_group].count += 1; } catch(e) {}
    }
    let groupScoreArray = Utils.createObjectToArray(groupScore);
    
    return (
      <div className="summary-group-score">
        <div className="group-item-box">
          { groupScoreArray.map((d, key) => {
            let per = Math.round((d.count / total_count) * 100);
            if( isNaN(per) || per == 'Infinity' ) per = 0;
            
            let color = (d.count > 0) ? 'color_'+ d.color : '';
            
            return (
              <div key={key} className={'group-item '+ color}>
                <div className="group-item-contents">
                  <i>{d.name}</i><span>{d.count}</span><i>人 ({per}%)</i>
                </div>
              </div>
            );
          })}
        </div>
        
        { (targets.length > 0)
          ? <Influencers base={data} targets={targets} />
          : <div className="influencer-none-msg">インフルエンサーが登録されていません。<ProgressAdditionInfluencer base={data} button={<span>こちら</span>} />から追加をしましょう</div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;